import withInjection from '@piconetworks/with-injection'
import Logout from 'common/components/Logout'

import Lifecycle from 'common/modules/lifecycle'
import Internal from 'common/modules/internal'
import Loader from 'common/modules/loader'
import xFrame from 'common/xFrame'

const mapStateToProps = (state) => ({
    publisherId: Loader.selectors.publisherId(state),
    userLoader: Loader.selectors.topScopeLoader(state),
    disableLoading: true,
})

const mapDispatchToProps = (dispatch) => ({
    logout: ({ payload }) => {
        dispatch(Internal.creators.sendMessage({
            payload: {
                target: 'pico_arbiter',
                ...Lifecycle.creators.userLogout({ payload }),
            },
        }))
        xFrame.menu.logout({ dispatch })
    },
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    logout: () => {
        dispatchProps.logout({
            payload: stateProps.userLoader,
        })
    },
})

const InjectedLogout = withInjection(Logout, {
    mapStateToProps,
    mapDispatchToProps,
    mergeProps,
})

export default InjectedLogout
